import Vue from "vue";

import VueMasonry from "vue-masonry-css";

import { LayoutsPlugin } from "@/layouts/layouts";
import { ManagerPlugin } from "@/components/components";
import { PageElements } from "@/page_elements/components";
import AutoRotate from "@/page_elements/AutoRotate";
import VueToast from "vue-toast-notification";
import "vue-toast-notification/dist/theme-sugar.css";
import AsyncComputed from "vue-async-computed";
import { consoleLog, redirect } from "@/helpers";
import VModal from "vue-js-modal";
import LongPress from 'vue-directive-long-press';
import { version } from "/package";
import VueLazyLoad from 'vue-lazyload'
import moment from 'moment';
require('moment/locale/nl')
require('moment/locale/nl-be')

Vue.use(LayoutsPlugin);
Vue.use(ManagerPlugin);
Vue.use(PageElements);
Vue.use(VueLazyLoad)

Vue.use(VueMasonry);
Vue.use(AutoRotate);
Vue.use(VModal, { dynamic: true });
Vue.use(AsyncComputed);
Vue.use(VueToast);
Vue.use(require('vue-moment'), {
  moment
});

Vue.directive('long-press', LongPress);
Vue.mixin({
  methods: {
    consoleLog: consoleLog,
    redirect: redirect
  }
});

Vue.config.productionTip = false;
Vue.prototype.$version = version;

if (process.env.NODE_ENV === "production") {
  Vue.config.devtools = false;
}
